import apiClient from "../axiosClient";
import { apiCallWrapper } from "../utils/commonUtils";

export default class PDBService {
    public static async switchPDB(pdbID: string) {
        const response = await apiCallWrapper(() => apiClient.post('/api/v1/pdb/switch-pdb', {
            pdb_id: pdbID
        }));
        if (response && response.status === 200) {
            return response.data;
        }
    }
};